module.exports = __webpack_public_path__ + "img/bili_list.656ec67e.png";